// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,


  /* URL_SERVICIOS: 'http://localhost:3000/api/v1',
  SECRET_KEY: '0ce109dc58c46bda93c22ddd1154d66b',
 */

  URL_SERVICIOS: 'https://testnomfargate.factorgfcleasing.com/api/v1',
  SECRET_KEY: '0375313f4dc135960906d5f642f5f154',


  URL_BASE_TUIDENTIDAD: 'https://dev.tuidentidad.com/api/',
  CLIENTE: 'LEASING',
  AWS: {
    accessKeyId: "",
    secretAccessKey: "",
    region: '',
    folder: '',
    bucketNomina: ''
  },
  firebase: {

    apiKey: "AIzaSyDpDtnejjtDCPH-vqrleaE64KQpXK8eAL4",
  
    authDomain: "testnomina-f377d.firebaseapp.com",
  
    projectId: "testnomina-f377d",
  
    storageBucket: "testnomina-f377d.appspot.com",
  
    messagingSenderId: "451147653180",
  
    appId: "1:451147653180:web:1033c0ccba52502cdc2339",
  
    measurementId: "G-KGQX6B8XMS"
  
  }
  
  
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
